// extracted by mini-css-extract-plugin
export default {"cards":"cards_cards__sNUqC","card":"cards_card__1vREh","iconbg":"cards_iconbg__lIo14","icon":"cards_icon__5vP-m","title":"cards_title__n53ps"};